module.exports = __webpack_public_path__ + "img/HC1017-90.c2c9f4a6.jpg";